<template>
  <div class="search-panel-results light" variant="primary">
    <b-btn
      class=" collapse-btn w-100"
      variant="success"
      v-b-toggle.collapse-address-search-results
      @click="toggleAddressSearchResultsCollapsed"
    >
      WYNIKI WYSZUKIWANIA<b-btn
        class="close pl-2 transform-y-2"
        @click.stop="handleChildButtonClick"
        @click="close"
      >
        <span aria-hidden="true">&times;</span></b-btn
      >
      <icon
        class="ml-1"
        v-show="addressSearchResultsExpanded"
        name="caret-down"
      ></icon>
      <icon
        class="ml-1"
        v-show="!addressSearchResultsExpanded"
        name="caret-right"
      ></icon>
    </b-btn>
    <b-collapse id="collapse-address-search-results" :visible="true">
      <div :class="{ blur: searchResultsLoading }">
        <b-alert :show="isDownloading" variant="info">
          <strong>Informacja.</strong>

          <span>Rozpoczęto pobieranie danych z wyszukiwarki.</span>
          <span>Proszę czekać.</span>
        </b-alert>
        <b-row class="justify-content-center mt-2 mb-2">
          <b-col md="6">
            <b-btn
              type="submit"
              variant="primary"
              class="col-md-12"
              size="md"
              @click="filter"
            >
              <span>Filtruj</span>
            </b-btn>
            <b-dropdown
              class="btn-block text-wrap mt-2 mb-2"
              id="dropdown-1"
              text="Eksportuj do:"
              variant="primary"
            >
              <b-dropdown-item @click="downloadResult({ format: 'pdf' })"
                >pdf bez zdjęcia</b-dropdown-item
              >
              <b-dropdown-item
                @click="downloadResult({ format: 'pdf', withGraphic: true })"
                >pdf ze zdjęciem</b-dropdown-item
              >
              <b-dropdown-item @click="downloadResult({ format: 'csv' })"
                >csv</b-dropdown-item
              >
              <b-dropdown-item @click="downloadResult({ format: 'xlsx' })"
                >xlsx</b-dropdown-item
              >
            </b-dropdown>
            <b-btn
              type="submit"
              variant="primary"
              class="col-md-12"
              size="md"
              @click="layerObjectDetails"
              :variant="toggleObjectDetailsState ? 'info' : 'primary'"
            >
              <span>Szczegóły obiektu na mapie</span>
            </b-btn>
          </b-col>
        </b-row>
        <!-- {{ filteredLayersItems }} -->
        <div
          v-for="(searchLayerItems, index) in searchLayersItems"
          :key="searchLayerItems.layerName"
        >
          <p class="font-weight-bold m-2">
            {{ searchLayerItems.layerName || 'Usługi w punktach adresowych' }}
          </p>
          <!-- <p class="m-2">
          Dane prezentowane są z ostatniej zakończonej inwentaryzacji.
        </p> -->
          <div
            v-if="
              layersItemsToShow[index] &&
                layersItemsToShow[index].length &&
                Object.keys(layersItemsToShow[index][0]).length
            "
            style="max-height: 400px; overflow-y: auto; width: 100%; overflow-x: auto;"
          >
            <b-table
              :no-border-collapse="true"
              :items="layersItemsToShow[index]"
              striped
              bordered
              :show-empty="true"
              empty-text="Brak danych"
            ></b-table>
          </div>
          <div class="m-2 mt-0" v-else>
            Brak danych do wyświetlenia
          </div>
        </div>
      </div>
    </b-collapse>
    <!-- <collapsible-widget
      id="collapsible-widget-wrapper"
      title="WYNIKI WYSZUKIWANIA"
      :accordion="accordion"
      :default-expanded="true"
    >
    </collapsible-widget> -->
  </div>
</template>

<script>
import LoadingOverlay from 'vue-loading-overlay';
import { Api as SearchApi } from '../api/api-wyszukiwarka';
import CollapsibleWidget from './CollapsibleWidget';
import { mapGetters } from 'vuex';
import {
  SET_APPLIED_FILTERS,
  WINDOW_NOTIFICATION_SHOW,
  WINDOW_ZOOM_TO_OWN_RANGE_SHOW,
  SEARCH_PANEL_SET_ITEMS
} from '../store/mutations.type';
import { WINDOW_SEARCH_RESULT_FILTER_SHOW } from '../store/mutations.type';
import {
  TOGGLE_OBJECT_DETAILS_STATE,
  TOGGLE_REPORT_DEMAND
} from '../store/actions.type';

export default {
  name: 'SearchPanelResults',
  props: {
    filterCriteria: {
      type: Object,
      default: () => ({})
    },
    accordion: {
      type: String,
      default: 'panel'
    }
  },
  components: {
    CollapsibleWidget,
    LoadingOverlay
  },
  data() {
    return {
      isLoading: false,
      formData: [],
      base64Png: null,
      filteredLayersItems: [],
      isFilterCriteriaEmpty: true,
      isDownloading: false,
      addressSearchResultsExpanded: true
    };
  },
  computed: {
    ...mapGetters([
      'searchLayersItems',
      'selectedAddressSearchItem',
      'appliedSearchResultFilters',
      'toggleObjectDetailsState',
      'searchResultsLoading'
    ]),
    // isFilterCriteriaEmpty() {
    //   return (
    //     !this.appliedSearchResultFilters ||
    //     Object.values(this.appliedSearchResultFilters).every(val => {
    //       return val === null || val === '';
    //     })
    //   );
    // },
    mappedLayersItems() {
      return this.searchLayersItems.map(searchLayerItems =>
        searchLayerItems.items.map(item => item.propertiesList)
      );
    },

    layersItemsToShow() {
      // window.console.log(this.isFilterCriteriaEmpty);
      if (this.isFilterCriteriaEmpty) {
        return this.mappedLayersItems;
      } else {
        return this.filteredLayersItems.map(searchLayerItems =>
          searchLayerItems.items.map(item => item.propertiesList)
        );
      }
    }
  },
  watch: {
    appliedSearchResultFilters(newFilterCriteria) {
      this.filterItems(newFilterCriteria);
      this.isFilterCriteriaEmpty =
        !this.appliedSearchResultFilters ||
        Object.values(this.appliedSearchResultFilters).every(val => {
          return val === null || val === '';
        });
    },
    searchLayersItems() {
      this.filterItems(this.appliedSearchResultFilters);
    }
  },
  created() {},
  mounted() {
    this.$store.commit(SET_APPLIED_FILTERS, null);
  },
  methods: {
    filterItems(newFilterCriteria) {
      if (!newFilterCriteria) {
        return;
      }

      this.filteredLayersItems = this.searchLayersItems
        .map(searchLayerItems => {
          return {
            ...searchLayerItems,
            items: searchLayerItems.items.filter(item => {
              const keys = Object.keys(item.propertiesList);
              if (keys && keys.length) {
                return Object.entries(newFilterCriteria).every(
                  ([key, value]) => {
                    const passes = !value || item.propertiesList[key] === value;
                    return passes;
                  }
                );
              }
              return false;
            })
          };
        })
        .filter(searchLayerItems => searchLayerItems.items.length > 0);
    },
    filter() {
      const distinctColumnValues = {};

      this.searchLayersItems.forEach(entry => {
        entry.items.forEach(item => {
          Object.entries(item.propertiesList).forEach(([key, value]) => {
            if (!distinctColumnValues[key]) {
              distinctColumnValues[key] = [];
            }

            if (!distinctColumnValues[key].includes(value) && value !== null) {
              distinctColumnValues[key].push(value);
            }
          });
        });
      });

      this.$store.commit(
        WINDOW_SEARCH_RESULT_FILTER_SHOW,
        distinctColumnValues
      );
    },
    layerObjectDetails() {
      this.$store.dispatch(TOGGLE_OBJECT_DETAILS_STATE);
      this.$emit('toggle-object-details');
    },
    createFormData() {
      this.formData = [];
      this.filteredLayersItems.forEach(searchLayerItems => {
        const keys = Object.keys(searchLayerItems.items[0].propertiesList);
        if (keys && keys.length) {
          this.formData.push({
            layerName: searchLayerItems.layerName || 'Usługi punkty adresowe',
            headers: Object.keys(searchLayerItems.items[0].propertiesList),
            values: searchLayerItems.items.map(function(item) {
              return Object.values(item.propertiesList);
            })
          });
        }
      });
      // window.console.log(this.searchLayersItems);
      // window.console.log(this.formData);
    },
    downloadResult(config) {
      switch (config.format) {
        case 'pdf':
          this.postExportPdfSearchResults(config);
          break;
        case 'csv':
          this.postExportCsvSearchResults();
          break;
        case 'xlsx':
          this.postExportXlsxSearchResults();
          break;
        default:
          this.postExportCsvSearchResults();
      }
      this.isDownloading = true;
      setTimeout(() => {
        this.isDownloading = false;
      }, 10000);
    },
    async postExportPdfSearchResults(config) {
      try {
        this.createFormData();
        this.base64Png = null;
        if (config.withGraphic) {
          this.base64Png = this.convertPngtoBase64(this.getMapPng());
        }
        const api = new SearchApi();
        // window.console.log(this.selectedAddressSearchItem);
        const response = await api.postExportPdfSearchResults(
          {
            body: {
              city: this.selectedAddressSearchItem
                ? this.selectedAddressSearchItem.city
                : '',
              street: this.selectedAddressSearchItem
                ? this.selectedAddressSearchItem.street
                : '',
              buildingNumber: this.selectedAddressSearchItem
                ? this.selectedAddressSearchItem.number
                : '',
              x: this.selectedAddressSearchItem
                ? this.selectedAddressSearchItem.x
                : '',
              y: this.selectedAddressSearchItem
                ? this.selectedAddressSearchItem.y
                : '',
              mapImage: this.base64Png || null,
              reportRequest: this.formData
            }
          },
          {
            ignoreGlobalError: true,
            download: true,
            withCredentials: false,
            hasContentType: false,
            jsonData: true
          }
        );
        if (response) {
        }
      } catch (error) {
        this.$store.commit(WINDOW_NOTIFICATION_SHOW, {
          message: error,
          type: 'error',
          title: 'Uwaga.'
        });
      }
    },
    convertPngtoBase64(dataURL) {
      return dataURL.split(',')[1];
    },
    getMapPng() {
      const mapContainer = document.getElementById('map');
      if (!mapContainer) {
        console.error('Map container element not found.');
        return;
      }

      const mapRendererCanvas = mapContainer.querySelector('canvas');
      if (!mapRendererCanvas) {
        console.error('Map renderer canvas not found.');
        return;
      }

      const captureCanvas = document.createElement('canvas');
      captureCanvas.width = mapRendererCanvas.width;
      captureCanvas.height = mapRendererCanvas.height;
      captureCanvas.setAttribute('crossorigin', 'anonymous');
      const context = captureCanvas.getContext('2d');

      context.drawImage(mapRendererCanvas, 0, 0);

      const image = new Image();
      image.crossOrigin = '*';
      image.src = captureCanvas.toDataURL('image/png');
      return image.src;
    },
    async postExportCsvSearchResults() {
      try {
        this.createFormData();

        const api = new SearchApi();
        const response = await api.postExportCsvSearchResults(
          {
            body: this.formData
          },
          {
            ignoreGlobalError: true,
            download: true,
            withCredentials: false,
            hasContentType: false,
            jsonData: true
          }
        );
        if (response) {
        }
      } catch (error) {
        this.$store.commit(WINDOW_NOTIFICATION_SHOW, {
          message: error,
          type: 'error',
          title: 'Uwaga.'
        });
      }
    },
    async postExportXlsxSearchResults() {
      try {
        this.createFormData();

        const api = new SearchApi();
        const response = await api.postExportXlsxSearchResults(
          {
            body: this.formData
          },
          {
            ignoreGlobalError: true,
            download: true,
            withCredentials: false,
            hasContentType: false,
            jsonData: true
          }
        );
        if (response) {
        }
      } catch (error) {
        this.$store.commit(WINDOW_NOTIFICATION_SHOW, {
          message: error,
          type: 'error',
          title: 'Uwaga.'
        });
      }
    },
    toggleAddressSearchResultsCollapsed() {
      this.addressSearchResultsExpanded = !this.addressSearchResultsExpanded;
    },
    close() {
      this.$store.commit(SEARCH_PANEL_SET_ITEMS, []);
    }
  }
};
</script>

<style>
#collapsible-widget-wrapper .collapsible-widget-body {
  /* max-height: 50vh !important; */
  overflow: auto;
}

/* width: 50%; */

/* .table-responsive {
  height: 100%;
} */
.blur {
  filter: blur(10px);
}
.search-panel-results {
  max-height: 100%;
  overflow: auto;
  display: block;
}
.collapse-btn {
  position: sticky;
  top: 0;
  padding: 20px;
  z-index: 999;
}
.transform-y-2 {
  transform: translateY(-2px);
}
</style>
